exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-class {\n\tfont-size: 1.2rem !important;\n}\n", ""]);

// exports
